/**
 * @typedef {Object} Sidebar
 * @property {string} type - The type of the item (e.g., "category").
 * @property {string} label - The label for the item.
 * @property {string[]} items - An array of items within the category.
 */

/** @type {Record<string, Sidebar[]>} */
export const sidebar = {

    docs: [
        {
            "type": "category",
            "label": "Getting Started",
            "items": [
                {
                    "type": "doc",
                    "label": "Introduction",
                    "id": "docs/getting-started/introduction"
                },
                {
                    "type": "doc",
                    "label": "Welcome",
                    "id": "docs/getting-started/welcome"
                },
                {
                    "type": "category",
                    "label": "Settings",
                    "items": [
                        {
                            "type": "doc",
                            "label": "Overview",
                            "id": "docs/getting-started/settings/overview"
                        },
                        {
                            "type": "doc",
                            "label": "Ai Models",
                            "id": "docs/getting-started/settings/ai-models"
                        },
                        {
                            "type": "doc",
                            "label": "Vector Database",
                            "id": "docs/getting-started/settings/vector-database"
                        },
                        {
                            "type": "doc",
                            "label": "Storage",
                            "id": "docs/getting-started/settings/storage"
                        },
                        {
                            "type": "doc",
                            "label": "Newra Api Key",
                            "id": "docs/getting-started/settings/newra-api-key"
                        },
                        {
                            "type": "doc",
                            "label": "Mail Settings",
                            "id": "docs/getting-started/settings/mail-settings"
                        }
                    ]                    
                },
                {
                    "type": "category",
                    "label": "Knowledgebase",
                    "items": [
                        {
                            "type": "doc",
                            "label": "Overview",
                            "id": "docs/getting-started/knowledgebase/overview"
                        },
                        {
                            "type": "doc",
                            "label": "Create Knowledgebase",
                            "id": "docs/getting-started/knowledgebase/create-knowledgebase"
                        },
                        {
                            "type": "doc",
                            "label": "Datasource",
                            "id": "docs/getting-started/knowledgebase/datasources"
                        },
                        {
                            "type": "doc",
                            "label": "GPT Prompt",
                            "id": "docs/getting-started/knowledgebase/gpt-prompt"
                        },
                        {
                            "type": "doc",
                            "label": "Playground",
                            "id": "docs/getting-started/knowledgebase/playground"
                        },
                        {
                            "type": "doc",
                            "label": "Settings",
                            "id": "docs/getting-started/knowledgebase/settings"
                        }                                             
                    ]                    
                },
                {
                    "type": "category",
                    "label": "App",
                    "items": [
                        {
                            "type": "doc",
                            "label": "Create App",
                            "id": "docs/getting-started/app/create-app",
                        },
                        {
                            "type": "doc",
                            "label": "GPT Prompt",
                            "id": "docs/getting-started/app/gpt-prompt",
                        },
                        {
                            "type": "doc",
                            "label": "Playground",
                            "id": "docs/getting-started/app/playground"
                        },
                        {
                            "type": "doc",
                            "label": "Theme",
                            "id": "docs/getting-started/app/theme",
                        }, 
                        {
                            "type": "doc",
                            "label": "Logs",
                            "id": "docs/getting-started/app/logs"
                        },                       
                        {
                            "type": "category",
                            "label": "Embeded / Share",
                            "items": [
                                {
                                    "type": "doc",
                                    "label": "Public URL",
                                    "id": "docs/getting-started/app/embed-share/public"
                                },
                                {
                                    "type": "doc",
                                    "label": "JavaScript Chat Widget",
                                    "id": "docs/getting-started/app/embed-share/chat-widget"
                                },
                                {
                                    "type": "doc",
                                    "label": "iFrame",
                                    "id": "docs/getting-started/app/embed-share/iframe"
                                },
                                {
                                    "type": "doc",
                                    "label": "API Token",
                                    "id": "docs/getting-started/app/embed-share/api-token"
                                },
                                {
                                    "type": "doc",
                                    "label": "Domain Restriction",
                                    "id": "docs/getting-started/app/embed-share/domain-restriction"
                                }
                            ]                    
                        }
                    ]            
                },                
                {
                    "type": "category",
                    "label": "Integration",
                    "items": [
                        {
                            "type": "doc",
                            "label": "Overview",
                            "id": "docs/getting-started/integration-guide/overview"
                        },
                        {
                            "type": "doc",
                            "label": "Whatsapp Business",
                            "id": "docs/getting-started/integration-guide/whatsapp-business"
                        },
                        {
                            "type": "doc",
                            "label": "Appsanax Whatsapp",
                            "id": "docs/getting-started/integration-guide/whatsapp-appsanax"
                        },
                        {
                            "type": "doc",
                            "label": "Telegram",
                            "id": "docs/getting-started/integration-guide/telegram"
                        }                            
                    ]                    
                },                
                {
                    "type": "category",
                    "label": "Account",
                    "items": [
                        {
                            "type": "doc",
                            "label": "Overview",
                            "id": "docs/getting-started/account/overview"
                        },
                        {
                            "type": "doc",
                            "label": "Profile",
                            "id": "docs/getting-started/account/profile"
                        },
                        {
                            "type": "doc",
                            "label": "Subscription",
                            "id": "docs/getting-started/account/subscription"
                        },
                        {
                            "type": "doc",
                            "label": "Billing",
                            "id": "docs/getting-started/account/billing"
                        }                            
                    ]                    
                }
            ]            
        }
    ]
  };
  